"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ButtonGroup_styled_1 = require("./ButtonGroup.styled");
function ButtonGroup(_a) {
    var options = _a.options, selectedOption = _a.selectedOption, onClick = _a.onClick, name = _a.name;
    return (react_1.default.createElement(ButtonGroup_styled_1.StyledButtonGroup, { role: "checkbox" }, options.map(function (option) { return (react_1.default.createElement(ButtonGroup_styled_1.StyledButtonGroupButton, { role: "checkbox", key: option.key, id: name + "-" + option.value, onClick: function (e) { return onClick(e, option); }, "aria-checked": selectedOption.value === option.value }, option.label)); })));
}
exports.default = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map